import { AgentsAiGraderIcon, Icon, type IconProps } from '@grammarly/design-system'

type AiGraderAgentIconProps = {
  accessibilityLabel?: string
  size: IconProps['size']
}

export const AiGraderAgentIcon = ({ size, accessibilityLabel }: AiGraderAgentIconProps) => {
  return (
    <Icon
      size={size}
      icon={AgentsAiGraderIcon}
      accessibilityLabel={accessibilityLabel ?? 'AI Grader Agent'}
    />
  )
}
